const addUserCentricsScript = (lang: string, userCentricsId: string): void => {
  if (
    typeof window === 'undefined' ||
    document.getElementById('usercentrics-cmp')
  )
    return

  const script = document.createElement('script')
  script.src = 'https://web.cmp.usercentrics.eu/ui/loader.js'
  script.setAttribute('id', 'usercentrics-cmp')
  script.setAttribute('data-language', lang)
  script.setAttribute('data-settings-id', userCentricsId)

  document.head.appendChild(script)
}

export default addUserCentricsScript
